import LaborLaws from '../LaborLaws/LaborLaws';
import { LegalContainer } from './Legal.styles';

const Legal = () => {
  return (
    <LegalContainer>
      <LaborLaws />
    </LegalContainer>
  );
};

export default Legal;
